import { Component, OnInit } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { faArrowRight, faArrowLeft, faSpinner } from '@fortawesome/free-solid-svg-icons'

import { BaseModal, JobTypeVendor } from '../../shared'

interface VendorItem {
    id: number
    name: string
}

@Component({
    selector: 'app-job-type-vendor-template',
    templateUrl: './job-type-vendor-template.component.html',
    standalone: true,
    imports: [CommonModule, FormsModule, FaIconComponent],
})
export class JobTypeVendorTemplateComponent extends BaseModal implements OnInit {
    faArrowRight = faArrowRight
    faArrowLeft = faArrowLeft
    faSpinner = faSpinner

    jobTypeId!: string
    allVendors: VendorItem[] = []
    selectedVendorIds: number[] = []

    availableVendors: VendorItem[] = []
    selectedVendors: VendorItem[] = []
    availableSearch = ''
    selectedSearch = ''

    ngOnInit(): void {
        if (!this.selectedVendorIds) {
            this.selectedVendorIds = []
        }
        this.updateLists()
    }

    updateLists() {
        this.availableVendors = this.allVendors.filter(v => !this.selectedVendorIds.includes(v.id))
        this.selectedVendors = this.allVendors.filter(v => this.selectedVendorIds.includes(v.id))
        this.filterAvailable()
        this.filterSelected()
    }

    filterAvailable() {
        if (this.availableSearch === '') {
            this.availableVendors = this.allVendors.filter(v => !this.selectedVendorIds.includes(v.id))
        } else {
            const searchLower = this.availableSearch.toLowerCase()
            this.availableVendors = this.allVendors.filter(
                v => !this.selectedVendorIds.includes(v.id) && v.name.toLowerCase().includes(searchLower),
            )
        }
    }

    filterSelected() {
        if (this.selectedSearch === '') {
            this.selectedVendors = this.allVendors.filter(v => this.selectedVendorIds.includes(v.id))
        } else {
            const searchLower = this.selectedSearch.toLowerCase()
            this.selectedVendors = this.allVendors.filter(
                v => this.selectedVendorIds.includes(v.id) && v.name.toLowerCase().includes(searchLower),
            )
        }
    }

    moveToSelected(vendor: VendorItem) {
        if (!this.selectedVendorIds.includes(vendor.id)) {
            this.selectedVendorIds.push(vendor.id)
            this.updateLists()
        }
    }

    moveToAvailable(vendor: VendorItem) {
        const index = this.selectedVendorIds.indexOf(vendor.id)
        if (index > -1) {
            this.selectedVendorIds.splice(index, 1)
            this.updateLists()
        }
    }

    moveAllToSelected() {
        this.availableVendors.forEach(v => {
            if (!this.selectedVendorIds.includes(v.id)) {
                this.selectedVendorIds.push(v.id)
            }
        })
        this.updateLists()
    }

    moveAllToAvailable() {
        this.selectedVendors.forEach(v => {
            const index = this.selectedVendorIds.indexOf(v.id)
            if (index > -1) {
                this.selectedVendorIds.splice(index, 1)
            }
        })
        this.updateLists()
    }

    onAvailableDoubleClick(selectElement: HTMLSelectElement) {
        const selectedValue = selectElement.value
        if (selectedValue) {
            const vendor = this.allVendors.find(v => v.id === +selectedValue)
            if (vendor) {
                this.moveToSelected(vendor)
            }
        }
    }

    onSelectedDoubleClick(selectElement: HTMLSelectElement) {
        const selectedValue = selectElement.value
        if (selectedValue) {
            const vendor = this.allVendors.find(v => v.id === +selectedValue)
            if (vendor) {
                this.moveToAvailable(vendor)
            }
        }
    }

    moveSelectedToRight(selectElement: HTMLSelectElement) {
        const selectedValue = selectElement.value
        if (selectedValue) {
            const vendor = this.allVendors.find(v => v.id === +selectedValue)
            if (vendor) {
                this.moveToSelected(vendor)
            }
        }
    }

    moveSelectedToLeft(selectElement: HTMLSelectElement) {
        const selectedValue = selectElement.value
        if (selectedValue) {
            const vendor = this.allVendors.find(v => v.id === +selectedValue)
            if (vendor) {
                this.moveToAvailable(vendor)
            }
        }
    }

    protected onSave(resolveSave: (result?: any) => void, rejectSave: (reason?: any) => void) {
        this.services.data
            .put<JobTypeVendor[]>('api/JobTypeVendor/SyncVendors', {
                jobTypeId: this.jobTypeId,
                vendorIds: this.selectedVendorIds,
            })
            .subscribe({
                next: result => {
                    resolveSave(result)
                },
                error: errorResult => {
                    this.services.notification.error('Failed to save vendor assignments')
                    rejectSave(errorResult)
                },
            })
    }
}
